import { Injectable, ViewChild } from '@angular/core';
import { GsPlayerService, PlayerFile, PlayerTheme, PlayerThemeDark } from 'gs-player';
import { GsPlayerComponent } from 'gs-player/lib/gs-player.component';
import { AttachmentAudio } from '../types/all.type';
import { AllService } from './all.service';
import { log } from '../functions';

@Injectable({
  providedIn: 'root'
})
export class MusicPlayerService {
  public playerData: { list: Array<PlayerFile | any>; open: boolean; lastPlayIndex?: number } = {
    list: [],
    open: false
  };
  public playerTheme: PlayerTheme = PlayerThemeDark;

  msaapDisplayTitle = false;
  msaapAutoPlay = false;
  msaapDisplayPlayList = false;
  msaapPageSizeOptions = [10, 20, 30];
  msaapDisplayVolumeControls = true;
  msaapDisplayRepeatControls = true;
  msaapDisplayArtist = false;
  msaapDisplayDuration = false;
  msaapDisablePositionSlider = true;
  @ViewChild('wrapPlayer') public wrapPlayer: GsPlayerComponent;
  constructor(public gsPlayer: GsPlayerService, public allService: AllService) {
    this.playerData = this.allService.getVarLocal('playlist', { list: [], open: false }, 'all');
    setTimeout(() => {
      const index = this.playerData.lastPlayIndex;
      if (index) {
        this.wrapPlayer.openFile(this.playerData.list[index], index);
      }
      this.gsPlayer.pause();
      setTimeout(() => {
        this.gsPlayer.pause();
      }, 1000)
    }, 30);
    this.gsPlayer.getState().subscribe((state) => {
      // console.log('state', state);
      if(!state.error) {
        const currentFile = this.wrapPlayer?.currentFile;
        // this.cd.detectChanges();
        if (this.wrapPlayer?.player && state.currentTime === state.duration && !state.playing) {
          if (currentFile?.index >= this.playerData.list?.length - 1) {
            this.wrapPlayer.openFile(this.playerData.list[0], 0);
          } else {
            this.wrapPlayer.next();
          }
        }
        // log('!!!', currentFile, this.playerData?.lastPlayIndex);
        // Save last play
        if (currentFile && currentFile.index != this.playerData?.lastPlayIndex && currentFile.index != 0) {
          if(this.playerData.lastPlayIndex != currentFile.index) {
            this.playerData.lastPlayIndex = currentFile.index;
            this.savePlayList();
          }
        }
      }

    });
  }
  savePlayList(): void {
    this.allService.setVarLocal('playlist', this.playerData, 'all');
  }
  addPlayList(attachment: AttachmentAudio): void {
    if(attachment.file_uri?.length === 0) return;
    this.showPlayer = true;
    const currentFile = this.wrapPlayer?.currentFile || {};
    const findIndexFile = this.playerData.list.findIndex((v) => v.file_id === attachment.file_id);
    if (findIndexFile === -1) {
      // add to playlist
      const file = {
        name: attachment.title || attachment.file_name,
        url: attachment.file_uri,
        artist: attachment.performer,
        file_id: attachment.file_id
      };
      this.playerData.list.push(file);
      setTimeout(() => {
        this.wrapPlayer.openFile(file, this.playerData.list?.length - 2);
      }, 50);
    } else {
      // play or open
      const { file } = <any>currentFile;
      if (file && file.file_id === attachment.file_id) {
        this.wrapPlayer.play();
      } else {
        this.wrapPlayer.openFile(this.playerData.list[findIndexFile], findIndexFile);
      }
    }
    this.savePlayList();
  }
  set showPlayer(val) {
    this.playerData.open = val;
    this.savePlayList();
    if (!val && this.wrapPlayer?.showPlayList) {
      this.wrapPlayer.showPlayList = false;
    }
    // this.cd.detectChanges();
  }
}
